export const checkAccessByProducts = (
  currentProductIds: string[],
  requiredProductIds: string[],
): boolean => {
  const requiredSet = new Set(requiredProductIds);

  return currentProductIds.some((productId) => requiredSet.has(productId));
};
